module.exports = __webpack_public_path__ + "static/media/81.a6bebe8.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/81.wav
// module id = G7Ub
// module chunks = 0